export const FRONTEND_CSS = "text-blue-800 bg-blue-100";
export const BACKEND_CSS = "text-yellow-800 bg-yellow-100";
export const MOBILE_CSS = "text-purple-800 bg-purple-100";
export const INFRASTRUCTURE_CSS = "text-red-800 bg-red-100";
export const OTHERS_CSS = "text-blue-800 bg-blue-100";